import { create } from 'zustand';
import type { User } from '../types';

interface AppState {
  // Auth
  token: string | null;
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  
  // Actions
  setToken: (token: string | null) => void;
  setUser: (user: User | null) => void;
  setAuthenticated: (value: boolean) => void;
  setLoading: (value: boolean) => void;
}

export const useStore = create<AppState>((set) => ({
  // Auth
  token: null,
  user: null,
  isAuthenticated: false,
  isLoading: true,
  
  // Actions
  setToken: (token) => set({ token }),
  setUser: (user) => set({ user }),
  setAuthenticated: (value) => set({ isAuthenticated: value }),
  setLoading: (value) => set({ isLoading: value }),
}));
